import { Component, Input, OnChanges, OnDestroy, OnInit, SimpleChange, SimpleChanges } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { OrderDependencyObject } from 'src/app/models/orders/order-details-dependencies/order-dependencies.model';
import { OrdersService, OrderSummary } from 'src/app/services/api/orders/orders.service';
import { ExternalUrlObject } from 'src/app/models/config/external-url-object.model';
import { ConfigService } from 'src/app/services/api/config/config.service';
import { isNullOrUndefined } from 'util';
import { NotificationLevel, NotificationsService } from 'src/app/services/api/notifications/notifications.service';
import { AppService } from 'src/app/app.service';
import { TranslateService } from '@ngx-translate/core';
import { MatDialog, MatDialogRef } from '@angular/material';
import { JsonComponent } from 'src/app/core/json/json.component';


@Component({
  selector: 'app-order-details-dependencies',
  templateUrl: './order-details-dependencies.component.html',
  styleUrls: ['./order-details-dependencies.component.css']
})
export class OrderDetailsDependenciesComponent implements OnChanges, OnInit, OnDestroy {

  _summary: OrderSummary;
  @Input()
  get summary(): any {
    return this._summary;
  }
  set summary(value: any) {
    this._summary = value;
    this.ngOnInit();
  }
  _params: any;
  @Input()
  get params(): any {
    return this._params;
  }
  set params(value: any) {
    this._params = value;
    this.ngOnInit();
  }
  @Input() isps: any[];

  previousId: string;

  dependencies: Array<OrderDependencyObject>;
  dependency: OrderDependencyObject;
  dataSource: MatTableDataSource<OrderDependencyObject>;
  columnsToDisplay: string[] = ['activityName', 'service', 'status', 'lastModification', 'reference'];
  externalURLs: Array<ExternalUrlObject>;
  hasLoadedDependencies: boolean;

  jsonRef: MatDialogRef<JsonComponent>;
  dependencyJson: any;

  constructor(
    private appService: AppService,
    private configService: ConfigService,
    private ordersService: OrdersService,
    private translateService: TranslateService,
    private notificationsService: NotificationsService,
    public dialog: MatDialog) {
  }

  ngOnInit() {
    if (this._params && this._summary && (this.previousId !== this._summary.id || this._summary.isReload)) {
      this.hasLoadedDependencies = false;
      this.previousId = this._summary.id;
      this.isLoadable();
    }
  }

  ngOnDestroy() {
  }

  ngOnChanges(changes: SimpleChanges): void {
  }


  private isLoadable(): void {
    if (!this.hasLoadedDependencies) {
      this.loadDependenciesInfo();
    } else {
      this.setDatasourceDependenciesTable(this.dependencies);
    }
  }

  private loadDependenciesInfo() {
    this.clearDependencies();
    this.ordersService.getDependencies(this.summary.id).subscribe(
      (orderDependenciesList) => {
        this.setDatasourceDependenciesTable(orderDependenciesList);
        this.hasLoadedDependencies = true;
      },
      (error) => {
        this.notificationsService.showNotification('No se han podido recuperar dependencias para esta orden', NotificationLevel.ERROR);
      }
    );
  }

  private setDatasourceDependenciesTable(orderDependenciesList: Array<OrderDependencyObject>) {
    this.clearDependencies();
    for (const dependency of orderDependenciesList) {
      this.dependency = dependency;
      this.dependencies.push(this.dependency);
    }
    this.displayDependencies(this.dependencies);
  }

  private displayDependencies(dependencies: Array<OrderDependencyObject>) {
    this.dataSource = new MatTableDataSource<OrderDependencyObject>(dependencies);
  }

  private clearDependencies() {
    this.dependencies = new Array<OrderDependencyObject>();
  }

  public openReference(referencePath: string) {
    this.ordersService.getDependencyInfo(referencePath).subscribe(
      (data: string) => {
        this.dependencyJson = data;
        delete this.dependencyJson._links;
        this.jsonRef = this.dialog.open(JsonComponent, {
          data: { title: 'Información de la dependencia', json: this.dependencyJson },
          width: '850px'
        });
      },
      (error) => {
        this.notificationsService.showNotification(this.translateService.instant('ORDERS_KEY.dependencyError'), NotificationLevel.ERROR);
      }
    )
  }

}
